import type { Post } from '$lib/api/rpc';
import { getContext, setContext } from 'svelte';
import { writable, type Writable } from 'svelte/store';

const postKey = Symbol();

export const setPostContextStore = (post: Post) => {
	setContext(postKey, writable(post));
};

export const getPostContextStore = () => {
	const context = getContext<Writable<Post>>(postKey);
	if (context !== undefined) return context;
	throw new Error('PostContext not set before use');
};
